// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';

const ContractSigned: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, entityId } = notification;
  const navigate = useNavigate();

  return (
    <Text>
      <Text
        span
        weight="bolder"
        variant="link"
        color="blue"
        onClick={() => navigate(`/events/${eventId}/contracts/${entityId}/preview`)}
        sx={{ cursor: 'pointer' }}
      >
        Vertrag
      </Text>
      {'  '}wurde unterschrieben.
    </Text>
  );
};

export default ContractSigned;
